// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"60fe8b97","992":"24fecc38"}[chunkId] + ".js";
};